import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createCostType,
    updateCostType,
    toggleCostTypeActive,
    reorderCostTypes,
} from '../api/costTypesApi';

function invalidateAll(queryClient) {
    queryClient.invalidateQueries({ queryKey: ['costTypes'] });
    queryClient.invalidateQueries({ queryKey: ['adminCostTypes'] });
}

export function useCreateCostType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (name) => createCostType(name),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useUpdateCostType() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name }) => updateCostType(id, name),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useToggleCostTypeActive() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => toggleCostTypeActive(id),
        onSuccess: () => invalidateAll(queryClient),
    });
}

export function useReorderCostTypes() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (orderedIds) => reorderCostTypes(orderedIds),
        onSuccess: () => invalidateAll(queryClient),
    });
}
